export * from './cookie-service/cookie.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-cookie-service/index.js
// module id = 208
// module chunks = 10